import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Belgaumairportcabservice() {



    const cardData = {




keyword: "Belgaum Airport Cab Service",

headingDescription: "Belgaum Taxi Service offers dependable Belgaum Airport cab service for airport transfers, business travel, family trips, hotel pickups, railway station transfers, and outstation journeys. We provide comfortable airport taxis with professional drivers, clean vehicles, and on-time pickup and drop facilities for passengers traveling to and from Belagavi Airport. Choose from Sedan, Ertiga, SUV, Innova, Innova Crysta, Tempo Traveller, and premium cars based on your travel needs. Our airport cab service includes flight schedule tracking, doorstep pickup, transparent pricing, easy booking, and 24/7 customer assistance for a smooth travel experience. Whether you are traveling for business, holidays, medical visits, or personal work, Belgaum Taxi Service ensures safe and convenient airport transportation from Belgaum Airport to major cities, corporate locations, tourist destinations, and nearby states.",

topPlaces: [
  {
    title: "Bangalore",
    description: "Bangalore is a major technology and business destination known for IT parks, corporate offices, and commercial centers. Belgaum Airport cab services provide comfortable transportation for professionals and families traveling to Bangalore."
  },
  {
    title: "Mumbai",
    description: "Mumbai is India's financial capital and an important destination for business, medical, and personal travel. Airport taxi services offer convenient connectivity from Belgaum to Mumbai."
  },
  {
    title: "Pune",
    description: "Pune is a leading IT and industrial city with educational institutions and corporate hubs. Travelers prefer private airport cabs for comfortable long-distance journeys."
  },
  {
    title: "Goa",
    description: "Goa is a popular leisure destination famous for beaches, resorts, churches, and sightseeing attractions. Belgaum Airport cabs provide easy transportation for tourists visiting Goa."
  },
  {
    title: "Hyderabad",
    description: "Hyderabad is a major technology and business city with IT parks, corporate offices, and tourist attractions. Airport taxi services provide reliable travel options for passengers."
  },
  {
    title: "Kolhapur",
    description: "Kolhapur is a nearby Maharashtra city known for Mahalaxmi Temple, business activities, shopping, and cultural heritage. It is a frequently traveled route from Belgaum Airport."
  },
  {
    title: "Hubballi",
    description: "Hubballi is an important commercial city in Karnataka with industries, educational institutions, and healthcare facilities. Airport cabs provide comfortable travel between Belgaum and Hubballi."
  },
  {
    title: "Dharwad",
    description: "Dharwad is known for universities, cultural heritage, and educational institutions. Airport transfers are useful for students, professionals, and visitors traveling to the city."
  },
  {
    title: "Gokarna",
    description: "Gokarna is a scenic coastal destination famous for beaches, temples, and peaceful surroundings. Tourists often choose private cabs for comfortable trips from Belgaum Airport."
  },
  {
    title: "Dandeli",
    description: "Dandeli is a popular adventure destination known for wildlife, forests, river rafting, and nature experiences. Airport cab services make travel convenient for tourists and groups."
  }
],




"services": [
  {
    "name": "Airport Taxi Belgaum",
    "description": "Book Airport Taxi Belgaum for safe, comfortable, and punctual airport transfers with professional chauffeurs and well-maintained AC vehicles. Get reliable pickup and drop services from Belgaum Airport with Sedan, Ertiga, Innova Crysta, and SUV cab options available for passengers, families, and business travelers."
  },
  {
    "name": "Belgaum Airport Taxi",
    "description": "Choose Belgaum Airport Taxi for hassle-free airport transportation with experienced drivers, clean vehicles, affordable fares, and timely service. Enjoy convenient airport pickup and drop facilities with doorstep cab availability for local and outstation travel."
  },
  {
    "name": "Belgaum Airport Taxi Service",
    "description": "Book Belgaum Airport Taxi Service for reliable airport transfers with professional drivers, comfortable seating, and smooth travel experiences. Our taxi services are suitable for arrivals, departures, business trips, family travel, and long-distance journeys."
  },
  {
    "name": "Belgaum Airport to Goa Taxi Fare",
    "description": "Get affordable Belgaum Airport to Goa Taxi Fare with comfortable AC cabs and experienced chauffeurs. Travel conveniently from Belgaum Airport to North Goa, South Goa, and popular destinations with flexible one way and round trip options."
  },
  {
    "name": "Belgaum to Goa Airport Taxi Charges",
    "description": "Check Belgaum to Goa Airport Taxi Charges for budget-friendly and reliable airport transfer services. Choose from Sedan, Ertiga, Innova Crysta, and SUV vehicles with transparent pricing and professional driver assistance."
  },
  {
    "name": "Goa Airport to Belgaum Taxi",
    "description": "Book Goa Airport to Belgaum Taxi for comfortable and safe transportation between Goa Airport and Belgaum. Enjoy timely pickup, spacious vehicles, experienced chauffeurs, and convenient travel solutions for personal and business journeys."
  },
  {
    "name": "Taxi from Belgaum Airport",
    "description": "Hire Taxi from Belgaum Airport for quick and reliable transportation to nearby cities and destinations. Get clean AC cars, professional drivers, doorstep drop services, and flexible cab options according to your travel needs."
  },
  {
    "name": "Best Taxi Service in Belgaum",
    "description": "Choose the Best Taxi Service in Belgaum offering premium vehicles, skilled chauffeurs, affordable rates, and dependable travel solutions. Perfect for airport transfers, local rides, outstation trips, corporate travel, and family journeys."
  },
  {
    "name": "Best Cab Service in Belgaum",
    "description": "Book the Best Cab Service in Belgaum for comfortable and reliable transportation with modern vehicles and experienced drivers. Enjoy convenient booking options for airport travel, local transportation, and outstation destinations."
  },
  {
    "name": "Taxi Service in Belgaum",
    "description": "Get Taxi Service in Belgaum for safe and affordable travel with professional chauffeurs and well-maintained vehicles. Our taxi solutions include local rides, airport transfers, corporate travel, and long-distance cab services."
  },
  {
    "name": "Cab Service in Belgaum",
    "description": "Choose Cab Service in Belgaum for reliable transportation with multiple vehicle choices including Sedan, Ertiga, Innova Crysta, and SUV cabs. Enjoy comfortable journeys with experienced drivers and easy booking facilities."
  },
  {
    "name": "Belgaum Taxi Service",
    "description": "Book Belgaum Taxi Service for convenient city travel, airport transfers, and outstation journeys. Experience safe rides with clean vehicles, professional drivers, transparent pricing, and flexible travel options."
  },
  {
    "name": "Belgaum Cab Service",
    "description": "Reserve Belgaum Cab Service for affordable and dependable travel solutions. Our chauffeur-driven cabs are ideal for airport pickup, family trips, business travel, sightseeing, and intercity transportation."
  },
  {
    "name": "Online Taxi Booking in Belgaum",
    "description": "Complete Online Taxi Booking in Belgaum with easy reservations, quick confirmation, and multiple cab options. Book comfortable taxis for airport transfers, local travel, and outstation trips with flexible scheduling."
  },
  {
    "name": "Online Cab Booking in Belgaum",
    "description": "Book Online Cab Booking in Belgaum services with simple booking procedures, transparent fares, and reliable customer support. Choose from different vehicle categories for personal, corporate, and family travel requirements."
  },
  {
    "name": "Outstation Cab Service in Belgaum",
    "description": "Hire Outstation Cab Service in Belgaum for safe and comfortable long-distance travel. Get one way cabs, round trip taxis, and customized travel packages with experienced chauffeurs and premium vehicles."
  },
  {
    "name": "One Way Cab Service in Belgaum",
    "description": "Book One Way Cab Service in Belgaum for economical single-trip travel without return charges. Enjoy fixed pricing, comfortable AC vehicles, professional drivers, and convenient doorstep pickup facilities."
  },
  {
    "name": "Local Taxi Service in Belgaum",
    "description": "Choose Local Taxi Service in Belgaum for smooth city transportation, quick rides, and daily travel needs. Get reliable cabs for shopping, meetings, sightseeing, airport transfers, and local destinations."
  },
  {
    "name": "Airport Taxi Service in Belgaum",
    "description": "Book Airport Taxi Service in Belgaum for timely airport pickup and drop with experienced chauffeurs and comfortable vehicles. Enjoy stress-free airport transfers with 24x7 cab availability."
  },
  {
    "name": "Belgaum Airport Cab Service",
    "description": "Reserve Belgaum Airport Cab Service for reliable airport transportation with clean AC cars and professional drivers. Experience smooth pickup and drop services with affordable fares and convenient booking options."
  },
  {
    "name": "Innova Crysta Cab in Belgaum",
    "description": "Book Innova Crysta Cab in Belgaum for premium and spacious travel with luxury seating, large luggage capacity, and experienced chauffeurs. Ideal for airport transfers, corporate trips, family tours, and outstation journeys."
  },
  {
    "name": "Ertiga Cab Service in Belgaum",
    "description": "Choose Ertiga Cab Service in Belgaum for comfortable 6 to 7 seater travel with affordable pricing and spacious interiors. Perfect for family trips, airport transfers, group travel, and outstation routes."
  },
  {
    "name": "Cheap Taxi Service in Belgaum",
    "description": "Find Cheap Taxi Service in Belgaum with budget-friendly fares, quality vehicles, and reliable chauffeur services. Enjoy affordable transportation without compromising safety, comfort, and service standards."
  },
  {
    "name": "24/7 Taxi Service in Belgaum",
    "description": "Get 24/7 Taxi Service in Belgaum with round-the-clock cab availability, professional drivers, and well-maintained vehicles. Travel anytime with reliable taxi solutions for emergency, airport, and outstation requirements."
  },
  {
    "name": "Private Taxi Service in Belgaum",
    "description": "Choose Private Taxi Service in Belgaum for exclusive chauffeur-driven travel with privacy, comfort, and flexible schedules. Ideal for families, corporate travelers, airport transfers, and personalized journeys."
  },
  {
    "name": "Reliable Cab Service in Belgaum",
    "description": "Experience Reliable Cab Service in Belgaum with trusted drivers, comfortable vehicles, affordable pricing, and timely service. We provide dependable taxi solutions for local travel, airport transportation, and outstation trips."
  }
],
"tableData": [
  ["Airport Taxi Belgaum", "Belgaum Airport Taxi"],
  ["Belgaum Airport Taxi Service", "Belgaum Airport to Goa Taxi Fare"],
  ["Belgaum to Goa Airport Taxi Charges", "Goa Airport to Belgaum Taxi"],
  ["Taxi from Belgaum Airport", "Best Taxi Service in Belgaum"],
  ["Best Cab Service in Belgaum", "Taxi Service in Belgaum"],
  ["Cab Service in Belgaum", "Belgaum Taxi Service"],
  ["Belgaum Cab Service", "Online Taxi Booking in Belgaum"],
  ["Online Cab Booking in Belgaum", "Outstation Cab Service in Belgaum"],
  ["One Way Cab Service in Belgaum", "Local Taxi Service in Belgaum"],
  ["Airport Taxi Service in Belgaum", "Belgaum Airport Cab Service"],
  ["Innova Crysta Cab in Belgaum", "Ertiga Cab Service in Belgaum"],
  ["Cheap Taxi Service in Belgaum", "24/7 Taxi Service in Belgaum"],
  ["Private Taxi Service in Belgaum", "Reliable Cab Service in Belgaum"]
],





whychoose: [
  {
    WhyChooseheading: "Reliable Belgaum Airport Cab Service",
    WhyChoosedescription: "Belgaum Taxi Service provides comfortable airport taxi services from Belgaum Airport with professional drivers, clean vehicles, and timely pickup and drop facilities."
  },
  {
    WhyChooseheading: "On-Time Airport Pickup & Drop",
    WhyChoosedescription: "Reach your flight on time or get a smooth airport transfer with our punctual cab services available for arrivals and departures."
  },
  {
    WhyChooseheading: "Pickup from Anywhere in Belgaum",
    WhyChoosedescription: "Book airport cabs from homes, hotels, offices, railway stations, and nearby locations with convenient doorstep pickup."
  },
  {
    WhyChooseheading: "Wide Range of Airport Cab Options",
    WhyChoosedescription: "Choose from Sedan, Swift Dzire, Ertiga, Innova, Innova Crysta, SUVs, and premium vehicles based on your comfort and luggage requirements."
  },
  {
    WhyChooseheading: "Professional Airport Drivers",
    WhyChoosedescription: "Our experienced chauffeurs provide safe driving, route knowledge, and reliable service for a stress-free airport journey."
  },
  {
    WhyChooseheading: "Affordable Airport Taxi Fare",
    WhyChoosedescription: "Enjoy competitive airport cab rates with transparent pricing, flexible booking options, and no hidden charges."
  },
  {
    WhyChooseheading: "Local & Outstation Airport Transfers",
    WhyChoosedescription: "Our Belgaum Airport taxis are available for local travel, business trips, family visits, and outstation destinations across Karnataka and nearby states."
  },
  {
    WhyChooseheading: "24/7 Airport Cab Booking Support",
    WhyChoosedescription: "Book your Belgaum Airport cab anytime with quick confirmation and dedicated customer assistance for smooth travel."
  }
]

};

const faqData = [
  {
    question: "Does Belgaum Taxi Service provide Belgaum Airport Cab Service?",
    answer: "Yes, we provide reliable airport pickup and drop services from Belgaum Airport with comfortable vehicles and professional drivers."
  },
  {
    question: "Can I book a taxi from Belgaum Airport to my destination?",
    answer: "Yes, you can book a cab from Belgaum Airport to hotels, homes, offices, railway stations, and nearby cities."
  },
  {
    question: "Which vehicles are available for Belgaum Airport transfers?",
    answer: "We offer Sedan, Swift Dzire, Ertiga, Innova, Innova Crysta, SUVs, and premium cars for airport travel."
  },
  {
    question: "Is Belgaum Airport cab service available 24/7?",
    answer: "Yes, our airport taxi service is available round the clock for early morning flights, late-night arrivals, and scheduled transfers."
  },
  {
    question: "Can I book a cab from Belgaum Airport for outstation travel?",
    answer: "Yes, airport taxis are available from Belgaum Airport to destinations like Goa, Bangalore, Mumbai, Pune, Hubli, and other cities."
  },
  {
    question: "Do you provide pickup according to flight timings?",
    answer: "Yes, we arrange airport pickups based on your flight arrival and departure schedule."
  },
  {
    question: "Are toll and parking charges included in the airport taxi fare?",
    answer: "Toll charges, parking fees, airport entry charges, and other applicable charges are generally billed separately unless included in the confirmed quotation."
  },
  {
    question: "Can I book an airport cab for corporate travel?",
    answer: "Yes, we provide airport transportation solutions for corporate executives, employees, and business travelers."
  },
  {
    question: "Do you provide round-trip airport taxi service?",
    answer: "Yes, round-trip airport cab bookings are available with flexible pickup and return schedules."
  },
  {
    question: "How can I book a Belgaum Airport Cab Service?",
    answer: "Share your pickup location, flight details, destination, travel date, passenger count, and preferred vehicle to receive an instant quotation."
  }
];

const testimonials = [
  {
    id: 1,
    name: "Mr. Arjun Kulkarni",
    feedback: "The Belgaum Airport cab service was excellent. The driver arrived on time, the vehicle was clean, and the airport transfer was smooth and comfortable.",
    rating: 5
  },
  {
    id: 2,
    name: "Mrs. Neha Patil",
    feedback: "We booked an airport taxi for our family trip and had a great experience. The driver was professional, and the service was reliable from pickup to drop.",
    rating: 5
  }
];





    const Images = [
        { place: "/images/keyword/1.jpg", text: "Cab Service in Belgaum", link: "Cab-Service-in-Belgaum" },
        { place: "/images/keyword/2.jpg", text: "Belgaum Taxi Service", link: "Belgaum-Taxi-Service" },
        { place: "/images/keyword/3.jpg", text: "Belgaum to Goa Cab", link: "Belgaum-to-Goa-Cab" },
        { place: "/images/keyword/4.jpg", text: "Belgaum to Mahabaleshwar Cab", link: "Belgaum-to-Mahabaleshwar-Cab" },
        { place: "/images/keyword/5.jpg", text: "Belgaum to Kerala Cab Service", link: "Belgaum-to-Kerala-Cab-Service" },
        { place: "/images/keyword/6.jpg", text: "Goa to Belgaum Cab", link: "Goa-to-Belgaum-Cab" },
        { place: "/images/keyword/7.jpg", text: "Belgaum to Mumbai Cab", link: "Belgaum-to-Mumbai-Cab" },
        { place: "/images/keyword/8.jpg", text: "Belgaum to Bangalore Cab", link: "Belgaum-to-Bangalore-Cab" },
        { place: "/images/keyword/9.jpg", text: "Goa Cab Service", link: "Goa-Cab-Service" },
        { place: "/images/keyword/10.jpg", text: "Taxi Service in Goa", link: "Taxi-Service-in-Goa" },
        { place: "/images/keyword/11.jpg", text: "Cheapest Cab Service in Goa", link: "Cheapest-Cab-Service-in-Goa" },
        { place: "/images/keyword/12.jpg", text: "Corporate Cab Services in Belgaum", link: "Corporate-Cab-Services-in-Belgaum" },
        { place: "/images/keyword/13.jpg", text: "Innova Crysta Rent in Belgaum", link: "Innova-Crysta-Rent-in-Belgaum" },
        { place: "/images/keyword/14.jpg", text: "Ertiga on Rent in Belgaum", link: "Ertiga-on-Rent-in-Belgaum" },
        { place: "/images/keyword/15.jpg", text: "Tempo Traveller Rent in Belgaum", link: "Tempo-Traveller-Rent-in-Belgaum" },
        { place: "/images/keyword/16.jpg", text: "Mini Bus Rental Belgaum", link: "Mini-Bus-Rental-Belgaum" },
        { place: "/images/keyword/17.jpg", text: "Swift Dzire on Rent in Belgaum", link: "Swift-Dzire-on-Rent-in-Belgaum" },
        { place: "/images/keyword/18.jpg", text: "Urbania on Rent in Belgaum", link: "Urbania-on-Rent-in-Belgaum" },
        { place: "/images/keyword/19.jpg", text: "Wedding Car Rental in Belgaum", link: "Wedding-Car-Rental-in-Belgaum" },
        { place: "/images/keyword/20.jpg", text: "Cabs in Belgaum", link: "Cabs-in-Belgaum" },
        { place: "/images/keyword/21.jpg", text: "Belgaum to Hubli Cab", link: "Belgaum-to-Hubli-Cab" },
        { place: "/images/keyword/22.jpg", text: "Belgaum to Dharwad Cab", link: "Belgaum-to-Dharwad-Cab" },
        { place: "/images/keyword/23.jpg", text: "Belgaum to Kolhapur Cab", link: "Belgaum-to-Kolhapur-Cab" },
        { place: "/images/keyword/24.jpg", text: "Belgaum Airport Cab Service", link: "Belgaum-Airport-Cab-Service" },
        { place: "/images/keyword/25.jpg", text: "Belgaum to Bagalkot Cab", link: "Belgaum-to-Bagalkot-Cab" },
    ];









const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Belgaum Airport Cab Service",
  "image": "https://www.belgaumtaxiservice.com/assets/images/belgaum-airport-cab-service.webp",
  "description":
    "Book Belgaum Airport Cab Service with Belgaum Taxi Service for safe, comfortable, and reliable airport transfers. We provide airport pickup and drop taxi services from Belgaum Airport to Goa, Belgaum city, and nearby destinations with Sedan, Ertiga, SUV, Innova, and Innova Crysta cabs available 24x7.",
  "brand": {
    "@type": "Brand",
    "name": "Belgaum Taxi Service"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "8517"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "Starting From ₹12/Km",
    "availability": "https://schema.org/InStock",
    "url": "https://www.belgaumtaxiservice.com/belgaum-airport-cab-service"
  }
};





    return (
        <div>


<Helmet>
  <title>Belgaum Airport Cab Service | Airport Taxi Booking | +91 8722158435</title>

  <meta
    name="description"
    content="Book Belgaum Airport Cab Service with Belgaum Taxi Service for reliable airport pickup and drop taxi services. Get affordable airport taxis from Belgaum Airport with Sedan, Ertiga, SUV, Innova, and Innova Crysta cabs available 24x7 for local and outstation travel."
  />

  <meta
    name="keywords"
    content="Airport taxi belgaum, Belgaum airport taxi, Belgaum airport taxi service, Belgaum airport to goa taxi fare, Belgaum to goa airport taxi charges, goa airport to belgaum taxi, taxi from belgaum airport, best taxi service in belgaum, Best Taxi Service Belgaum, Belgaum Airport Cab Service, Belgaum Airport Pickup Taxi, Belgaum Airport Drop Taxi, Airport Cab Booking Belgaum"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>





            <div className="page-headder bg-section parallaxie">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-12">
                            <div className="page-header-box text-white">
                                <h1 className="text-anime-style-3 text-center text-white">
                                    {cardData.keyword}
                                </h1>
                            </div>
                        </div>
                    </div>
                </div>
            </div>













            <section>
                <div className="container-fluid p-0" >
                    <div className="row container-fluid px-md-2">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/24.jpg' alt='img' className='img-fluid' />
                            <h3 className="py-1"
                                style={{
                                    color: '#183765', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >Belgaum Taxi Service: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>

                            <div className="topPlaces">

                                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                                {cardData.topPlaces.map((place, index) => (
                                    <article key={index} className="placeCard borderr" tabIndex="0">
                                        <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                                        <div className="placeBody">
                                            <h4 className="placeTitle">{place.title}</h4>
                                            <p className="placeDesc">{place.description}</p>

                                        </div>

                                        <span className="placeArrow" aria-hidden>›</span>
                                    </article>
                                ))}
                            </div>


                            {/* <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                  
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div> */}


                            <div className="services-section">
                                {cardData.services.map((service, index) => (
                                    <div className="service-card" key={index}>
                                        <div className="service-content">
                                            <h4>{service.name}</h4>
                                            <span className="line"></span>
                                            <p>{service.description}</p>
                                        </div>

                                        <div className="service-icon">
                                            <i className="fas fa-arrow-right"></i>
                                        </div>
                                    </div>
                                ))}
                            </div>

                            <div className="keyword-grid">
                                {cardData.tableData.flat().map((keyword, index) => (
                                    <div key={index} className="keyword-item">
                                        <span className="keyword-bullet">-</span>
                                        {keyword}
                                    </div>
                                ))}
                            </div>



                            <div id="why-choose-section" className="why-choose-section">

                                <h2 className="section-title text-dark">
                                    Why Choose <span>Belgaum Taxi Service</span>
                                </h2>

                                <div className="bento-grid">
                                    {cardData.whychoose.map((item, index) => (
                                        <div className="bento-card" key={index}>

                                            <div className="bento-number">
                                                {String(index + 1).padStart(2, "0")}
                                            </div>

                                            <h4>{item.WhyChooseheading}</h4>

                                            <p>{item.WhyChoosedescription}</p>

                                        </div>
                                    ))}
                                </div>

                            </div>



                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Belgaum Taxi Service </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                <FaqSection
                                                    title=""
                                                    subtitle=""
                                                    items={faqData}
                                                />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <TestimonialSectionKeyword
                                testimonials={testimonials}
                            />


                            <ContactShowcase keyword={cardData.keyword} />
                        </div>

                        <div className='col-12 col-md-4' >
                            <div className="routeList">
                                {Images.map((e, i) => {
                                    const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                                    const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                                    return (
                                        <a
                                            key={e.link || i}
                                            href={href}
                                            className="routeItem"
                                            aria-label={e.text}
                                            {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                                        >
                                            <div className="routeThumb">
                                                <img src={e.place} alt="" loading="lazy" />
                                            </div>

                                            <div className="routeMeta">
                                                <h6 className="routeTitle">{e.text}</h6>
                                                <span className="routeUnderline" />
                                            </div>

                                            <span className="routeArrow" aria-hidden>›</span>
                                        </a>
                                    );
                                })}
                            </div>




                            <div>
                                <FleetHighway />
                            </div>
                            <div className="pc-contact">
                                <h4 className="pc-title">Contact Information</h4>

                                <div className="pc-grid">
                                    {/* Phones */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="fas fa-phone-alt"></i>
                                            <span>Phone Numbers</span>
                                        </header>

                                        <div className="pc-list">
                                            <a href="tel:+918722158435 " className="pc-call">+91 8722158435 </a>
                                        </div>

                                        <div className="pc-cta">
                                            <a
                                                href="https://wa.me/918722158435 "
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                className="pc-whats"
                                            >
                                                <i className="bi bi-whatsapp"></i> WhatsApp
                                            </a>
                                            <a href="tel:+918722158435 " className="pc-primary">
                                                Call Now
                                            </a>
                                        </div>
                                    </section>

                                    {/* Email */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="fa-solid fa-envelope"></i>
                                            <span>Email</span>
                                        </header>

                                        <a href="mailto:booking@belgaumtaxiservice.com" className="pc-email">
                                            booking@belgaumtaxiservice.com
                                        </a>
                                    </section>

                                    {/* Address */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="fa-solid fa-location-dot"></i>
                                            <span>Address</span>
                                        </header>

                                        <address className="pc-address">
                                            <strong>Belgaum Taxi Service</strong><br />
                                            P No 30 cCTS No 7023,
                                            Sector No 9 Malmaruti Anjaneya Nagar,
                                            Belgaum, Karnataka - 590017




                                        </address>
                                    </section>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Belgaumairportcabservice;